import { useState } from "react";
import { InputText, ModalForm } from "@ficatranquilo/contabilidade.com-ui";
import { focusFirstError } from "../../Common/FormPage";

const NAME_ID = "confidential-group-name";

// varchar(120) no banco
const NAME_MAX = 120;

/**
 * Nome do grupo confidencial: cria (sem `group`) ou renomeia. `onSave(name)` faz a
 * chamada; se ela lançar, o modal fica aberto (a tela já mostrou a mensagem do back).
 * Montado só aberto.
 */
export default function GroupNameModal({ group = null, onClose, onSave }) {
  const [name, setName] = useState(group?.name || "");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  function close() {
    if (!saving) onClose();
  }

  async function save() {
    const value = name.trim();
    if (!value) {
      setError("Informe o nome do grupo.");
      focusFirstError([NAME_ID]);
      return;
    }
    setSaving(true);
    try {
      await onSave(value);
    } catch {
      setSaving(false);
    }
  }

  return (
    <ModalForm
      $showModal
      $setShowModal={close}
      $noClose={saving}
      $isLoading={saving}
      $size="medium"
      $title={group ? "Renomear grupo" : "Novo grupo confidencial"}
      $contentBackground="N0"
      $actions={[
        { text: "Cancelar", action: close, variant: "outline", isDisabled: saving },
        { text: group ? "Salvar nome" : "Criar grupo", action: save, variant: "primary", isDisabled: saving },
      ]}
    >
      <InputText
        $idForm={NAME_ID}
        $label="Nome do grupo"
        $variant="default"
        $isRequired
        $errors={error}
        maxLength={NAME_MAX}
        placeholder="Ex.: Executivos"
        value={name}
        onChange={(e) => {
          setName(e.target.value);
          if (error) setError("");
        }}
      />
    </ModalForm>
  );
}
